import { Directive, OnDestroy, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[denyNonNumberTimepickerDirective]',
    standalone: false
})
export class DenyNonNumberTimepickerDirectiveDirective implements OnInit, OnDestroy {
  //element observer
  private mutationObserver: MutationObserver;

  constructor(private readonly renderer: Renderer2) { }

  //initialize
  ngOnInit(): void {
    this.observePopupInputDialog();
  }

  //destroy
  ngOnDestroy(): void {
    if(this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  }

  private observePopupInputDialog() {
    this.mutationObserver = new MutationObserver(() => {
      //ngx mat timepicker time inputs
      const dialogInputs = document.querySelectorAll('.timepicker-dial__control');

      dialogInputs.forEach(input => this.denyNonNumberInputs(input as HTMLInputElement));
    });

    //observe DOM changes
    this.mutationObserver.observe(document.body, {childList: true, subtree: true });
  }

  //implementation of input restriction to numbers only
  private denyNonNumberInputs(input: HTMLInputElement) {
    if(input.hasAttribute('data-restrict')) return;

    input.setAttribute('data-restrict', 'true');

    //implementation for typing
    this.renderer.listen(input, 'keydown', (event: KeyboardEvent) => {
      const numberRegex = /^[0-9:]$/;
      const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];

      if(!numberRegex.test(event.key) && !allowedKeys.includes(event.key)) {
        event.preventDefault();
      }
    });

    //implementation for pasting
    this.renderer.listen(input, 'paste', (event: ClipboardEvent) => {
      const pasted = event.clipboardData?.getData('text') ?? '';

      if(!/^[0-9:]$/.test(pasted)) {
        event.preventDefault();
      }
    });
  }
}